export default function PHP_strcoll() {
  return (
    <div>
      <h1>PHP_strcoll</h1>
    </div>
  );
}
